import App from './Router.svelte';

const app = new App({
	target: document.body,
	props: {
		
	}
});

export default app;